import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Chance } from 'chance';
import { Component } from 'react';
import { Badge, Button, Image } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { brand_colors } from '../helpers/brand_colors_helper';
import { t } from '../helpers/translation_helper';
import GetIcon from './icon_helper';
import { faAngleDown, faAngleUp, faCheckCircle, faEdit, faList, faMinusCircle, faPlus, faTimes, faTimesCircle, faTrash } from '@fortawesome/free-solid-svg-icons';

class SubjectCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            actionDDL: false,
            cardWidth: '33.33'
        }
    }

    componentDidMount() {
        this.resize()
        window.addEventListener('resize', this.resize)
    }
    resize = () => {
        //  1536 739
        //  1920 955
        let WIDTH = window.innerWidth
        let HEIGHT = window.innerHeight
        if (WIDTH > 1600) {
            if (this.state.cardWidth != '25') {
                this.setState({ cardWidth: '25' })
            }
        } else {
            if (this.state.cardWidth != '33.33') {
                this.setState({ cardWidth: '33.33' })
            }
        }
    }


    render() {
        let { actionDDL } = this.state
        // let linkTo = ''
        // let linkToStates = {}

        // let cardImage = require('../assets/images/noimage.png')
        // let name = 'Name Name Name'
        // let code = 'CODE'
        // let text1 = 'Name2'
        // let text2 = 'Name3'
        // let description = 'Create consistent cross-browser and cross-device checkboxes and radios with our completely rewritten checks component.'
        // let status = 1
        // let actions = [
        //     { name: 'Edit', iconName: faEdit, iconColor: brand_colors[this.props.defaultTheme.theme_id].color9, onClick: () => { } },
        //     { name: 'Delete', iconName: faTrashAlt, iconColor: brand_colors[this.props.defaultTheme.theme_id].color9, onClick: () => { } }
        // ]
        // let extraTexts = [
        //     { type: 'url', name: 'URL', value: 'www.google.com', iconName: null, image: require('../assets/images/add-button-small.png'), iconColor: brand_colors[this.props.defaultTheme.theme_id].color9, onClick: () => { } },
        //     { type: 'text', name: 'TOPIC', value: 'Some topic Name', icon: null, image: require('../assets/images/hyperlink.png'), iconColor: brand_colors[this.props.defaultTheme.theme_id].color9, onClick: () => { } }
        // ]

        if (!this.props.data) {
            return null
        }
        let { linkTo, linkToStates, cardImage, cardIcon, cardIconColor, name, code, text1, text2, actions, description, extraTexts, status, onClick, parent, mandatory, sessionsPerWeek } = this.props.data

        return (<div className='d-flex flex-row' key={this.props.key} style={{ width: 'calc(' + this.state.cardWidth + '% - 2rem)', backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, borderRadius: '1rem', margin: '0.6rem 0.8rem', position: 'relative', boxShadow: '-1px 2px 16px 2px rgba(0,0,0,0.1)', padding: 0 }}>
            <div className='d-flex flex-row' style={{ padding: '0.5rem', }}>
                <div style={{ borderRight: 'solid 1px #e0e0e0', paddingRight: '0.5rem', marginRight: '0.5rem' }}>
                    {(linkTo || onClick)
                        ? <Link to={linkTo} state={linkToStates} onClick={onClick}>
                            {cardImage && <Image src={cardImage} style={{ objectFit: 'contain', width: '6rem', height: '100%', backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, borderRadius: 7, marginBottom: 7 }} />}
                            {cardIcon && <GetIcon icon={cardIcon} style={{ width: '6rem', height: '100%', backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, borderRadius: 7, marginBottom: 7, color: (cardIconColor) ? cardIconColor : brand_colors[this.props.defaultTheme.theme_id].color4 }} />}
                        </Link>
                        : (cardImage) && <Image src={cardImage} style={{ objectFit: 'contain', width: '6rem', height: '100%', backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, borderRadius: 7, marginBottom: 7 }} />
                    }
                </div>

                <div className='d-flex flex-column '>
                    <div className='d-flex flex-column'>
                        <div>
                            <div>
                                {parent && <div><small style={{ fontSize: '1rem', opacity: 0.9 }}>{parent}</small></div>}
                                <strong style={{ fontSize: '1rem' }}>{name}</strong>
                                {code && <span className='mx-1 text-muted' style={{ fontSize: '0.9rem' }}>{code}</span>}
                            </div>
                        </div>
                        <div className='d-flex flex-row flex-wrap'>
                            {(status == 1 || status == 0) &&
                                <div>
                                    {(status == 1 || status == 0)
                                        ? <Badge className='me-2' bg={status == 1 ? 'success' : 'danger'}> {status == 1 ? t('Active') : t('Inactive')} </Badge>
                                        : <Badge className='me-2' bg={status.bg}> {status.name} </Badge>}
                                </div>
                            }
                            {mandatory &&
                                <div>
                                    <Badge className='me-2' bg={mandatory ? 'danger' : 'warning'}> {mandatory ? t('Mandatory') : t('Elective')} </Badge>
                                </div>
                            }
                            <div>
                                <Badge style={{ fontSize: 11 }} className='me-2' bg={'secondary'}>{'Session Per Week'}{': '}{sessionsPerWeek}</Badge>
                            </div>
                        </div>
                    </div>
                    {/* <div>
                        {extraTexts && extraTexts.map((v, i) => {
                            if (v.type == 'url') {
                                return <p key={i} className="mb-0" style={{ fontSize: '0.8rem' }}>
                                    <a href={v.value} target='_blank' >
                                        {v.image && <Image src={v.image} style={{ width: '1rem', height: '1rem' }} />}
                                        {v.icon && <FontAwesomeIcon icon={v.icon} color={v.iconColor} style={{ fontSize: '1rem', }} />}
                                        <span className='mx-1'>{v.name}</span>
                                    </a>
                                </p>
                            } else {
                                return <p key={i} title={v.name} className="mb-0" style={{ fontSize: '0.8rem' }}>
                                    {v.image && <Image src={v.image} style={{ width: '1rem', height: '1rem' }} />}
                                    {v.icon && <FontAwesomeIcon icon={v.icon} color={v.iconColor} style={{ fontSize: '1rem', }} />}
                                    <span className='mx-1'>{v.value}</span>
                                </p>
                            }
                        })}
                        {description && <span title={description} style={{ fontSize: '0.8rem', color: brand_colors[this.props.defaultTheme.theme_id].color9, opacity: 0.8 }}>{(description.length > 60) ? description.slice(0, 60) + '...' : description}</span>}
                    </div> */}
                    {actions && actions.length > 0 &&
                        <div style={{ marginTop: '0.5rem' }}>
                            <div className='d-flex align-items-center flex-row flex-wrap'>
                                {actions.map((v, i) => {
                                    if (v.type == 'edit') {
                                        return <div key={i} className='d-flex flex-column align-items-center justify-content-center cursor-pointer' style={{ marginRight: '0.5rem', }}>
                                            <Button variant={'warning'} size={'sm'} onClick={() => v.onClick()}>
                                                {v.iconName && <FontAwesomeIcon title={t(v.name)} icon={v.iconName} style={{ fontSize: '1rem' }} />}
                                            </Button>
                                        </div>
                                    } else if (v.type == 'delete') {
                                        return <div key={i} className='d-flex flex-column align-items-center justify-content-center cursor-pointer' style={{ marginRight: '0.5rem', }}>
                                            <Button variant={'danger'} size={'sm'} onClick={() => v.onClick()}>
                                                {v.iconName && <FontAwesomeIcon title={t(v.name)} icon={v.iconName} style={{ fontSize: '1rem' }} />}
                                            </Button>
                                        </div>
                                    } else {
                                        return (<div key={i} className='d-flex flex-column align-items-center justify-content-center cursor-pointer' style={{ marginRight: '0.5rem', }} onClick={() => v.onClick()} >
                                            {v.image && <Image title={t(v.name)} src={v.image} style={{ width: '1rem', height: '1rem' }} />}
                                            {v.iconName && <FontAwesomeIcon title={t(v.name)} icon={v.iconName} color={v.iconColor} style={{ fontSize: '1rem' }} />}
                                        </div>)
                                    }
                                })}
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>);
    }
}

const mapStateToProps = (state) => ({
    authData: state.auth.authData,
    defaultLanguage: state.language.defaultLanguage,
    defaultTheme: state.theme.defaultTheme
});

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps())(SubjectCard);
